/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientReferralViewRecipient } from './RecipientReferralViewRecipient';
import {
    RecipientReferralViewRecipientFromJSON,
    RecipientReferralViewRecipientFromJSONTyped,
    RecipientReferralViewRecipientToJSON,
    RecipientReferralViewRecipientToJSONTyped,
} from './RecipientReferralViewRecipient';

/**
 * 
 * @export
 * @interface RecipientReferralView
 */
export interface RecipientReferralView {
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    sender_facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    sender_facility_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    last_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    dob?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof RecipientReferralView
     */
    referral_type?: RecipientReferralViewReferralTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    target_discharge_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    sent_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    confirmed_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RecipientReferralView
     */
    closed_at?: Date | null;
    /**
     * 
     * @type {RecipientReferralViewRecipient}
     * @memberof RecipientReferralView
     */
    recipient: RecipientReferralViewRecipient;
}


/**
 * @export
 */
export const RecipientReferralViewReferralTypeEnum = {
    HomeHealth: 'home_health',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Dialysis: 'dialysis'
} as const;
export type RecipientReferralViewReferralTypeEnum = typeof RecipientReferralViewReferralTypeEnum[keyof typeof RecipientReferralViewReferralTypeEnum];


/**
 * Check if a given object implements the RecipientReferralView interface.
 */
export function instanceOfRecipientReferralView(value: object): value is RecipientReferralView {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('recipient' in value) || value['recipient'] === undefined) return false;
    return true;
}

export function RecipientReferralViewFromJSON(json: any): RecipientReferralView {
    return RecipientReferralViewFromJSONTyped(json, false);
}

export function RecipientReferralViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientReferralView {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_facility_name': json['sender_facility_name'] == null ? undefined : json['sender_facility_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'dob': json['dob'] == null ? undefined : (new Date(json['dob'])),
        'referral_type': json['referral_type'] == null ? undefined : json['referral_type'],
        'target_discharge_date': json['target_discharge_date'] == null ? undefined : (new Date(json['target_discharge_date'])),
        'sent_at': json['sent_at'] == null ? undefined : (new Date(json['sent_at'])),
        'confirmed_at': json['confirmed_at'] == null ? undefined : (new Date(json['confirmed_at'])),
        'closed_at': json['closed_at'] == null ? undefined : (new Date(json['closed_at'])),
        'recipient': RecipientReferralViewRecipientFromJSON(json['recipient']),
    };
}

export function RecipientReferralViewToJSON(json: any): RecipientReferralView {
    return RecipientReferralViewToJSONTyped(json, false);
}

export function RecipientReferralViewToJSONTyped(value?: RecipientReferralView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_facility_name': value['sender_facility_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'] == null ? undefined : ((value['dob'] as any).toISOString().substring(0,10)),
        'referral_type': value['referral_type'],
        'target_discharge_date': value['target_discharge_date'] == null ? undefined : ((value['target_discharge_date'] as any).toISOString().substring(0,10)),
        'sent_at': value['sent_at'] == null ? undefined : ((value['sent_at'] as any).toISOString()),
        'confirmed_at': value['confirmed_at'] == null ? undefined : ((value['confirmed_at'] as any).toISOString()),
        'closed_at': value['closed_at'] == null ? undefined : ((value['closed_at'] as any).toISOString()),
        'recipient': RecipientReferralViewRecipientToJSON(value['recipient']),
    };
}

